import { createApp } from 'vue'
import App from './App.vue'
const mountEl = document.querySelector('#kalc');

const app = createApp(App)
app.config.globalProperties.rootdata = { ...mountEl.dataset }
app.mount('#kalc')
